/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import type { SVGProps } from 'react';

export function NmSignInIcon(props: SVGProps<SVGSVGElement>) {
    return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M21.6 22.8v-2.4c0-1.3-.5-2.5-1.4-3.4-.9-.9-2.1-1.4-3.4-1.4H7.2c-1.3 0-2.5.5-3.4 1.4-.9.9-1.4 2.1-1.4 3.4v2.4"
                stroke="currentColor"
                strokeLinecap="square"
                strokeLinejoin="round"
            />
            <path
                d="M12 10.8c2.7 0 4.8-2.1 4.8-4.8 0-2.7-2.1-4.8-4.8-4.8-2.7 0-4.8 2.1-4.8 4.8 0 2.7 2.1 4.8 4.8 4.8z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
